<div class="sh-action-bar">
    <div class="sh-action-bar__group">
        <sh-action-group class="sh-action-bar__group__item" [actionGroup]="actionGroup"></sh-action-group>
    </div>
</div>
